import React from "react";
import useGetOrders from "../../../hooks/sales/useGetOrders";
import { format } from "date-fns";
import { Link } from "react-router-dom"; // Import Link

const Orders = ({ userId }) => {
  const { orders, loading, error } = useGetOrders(userId);

  if (loading)
    return (
      <p className="text-center mt-10 text-gray-500">Loading your orders...</p>
    );

  if (error)
    return (
      <p className="text-center mt-10 text-red-600">
        Error loading orders: {error}
      </p>
    );

  if (!orders.length)
    return (
      <p className="text-center mt-10 text-gray-500">No orders found.</p>
    );

  return (
    <div className="max-w-6xl mx-auto py-12 px-4">
      <h1 className="text-3xl font-bold text-purple-700 mb-10 text-center">
        Your Orders
      </h1>

      <div className="space-y-10">
        {orders.map((order) => (
          /* Wrap the card in a Link. Since it's a child of /protected, 
             the path matches your router definition: /protected/orders/:id */
          <Link
            key={order.id}
            to={`/protected/orders/${order.id}`}
            className="block group transition"
          >
            <div className="bg-white shadow-md rounded-2xl p-6 border border-gray-200 group-hover:shadow-xl group-hover:border-purple-300 transition">
              {/* Header */}
              <div className="flex flex-col sm:flex-row sm:justify-between sm:items-center border-b pb-4 mb-5">
                <div>
                  <h2 className="text-lg font-semibold text-gray-800">
                    Order <span className="text-gray-600 group-hover:text-purple-600 transition">#{order.id}</span>
                  </h2>
                  <p className="text-sm text-gray-500">
                    {order.createdAt?.toDate
                      ? format(order.createdAt.toDate(), "MMM dd, yyyy hh:mm a")
                      : "Date unavailable"}
                  </p>
                </div>

                <div className="flex flex-col sm:items-end mt-3 sm:mt-0">
                  <span
                    className={`px-3 py-1 text-sm font-medium rounded-full ${
                      order.status === "shipped"
                        ? "bg-blue-100 text-blue-700"
                        : order.status === "delivered"
                        ? "bg-green-100 text-green-700"
                        : "bg-yellow-100 text-yellow-700"
                    }`}
                  >
                    {order.status.charAt(0).toUpperCase() + order.status.slice(1)}
                  </span>
                  <p className="mt-1 font-semibold text-purple-700 text-lg">
                    ${order.totalAmount.toFixed(2)}
                  </p>
                </div>
              </div>

              {/* Products Preview */}
              <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 mb-5">
                {order.products?.map((item) => (
                  <div
                    key={item.sku}
                    className="flex items-center justify-between border rounded-lg p-3 bg-gray-50 group-hover:bg-white transition"
                  >
                    <div className="flex items-center gap-4">
                      <img
                        src={item.imageUrl || "https://via.placeholder.com/64"}
                        alt={item.name}
                        className="w-16 h-16 object-cover rounded-lg border"
                      />
                      <div>
                        <p className="font-medium text-gray-800">{item.name}</p>
                        <p className="text-sm text-gray-500">
                          Qty: {item.quantity}
                        </p>
                      </div>
                    </div>
                  </div>
                ))}
              </div>

              <div className="text-right text-sm font-medium text-purple-600 group-hover:translate-x-1 transition-transform">
                Manage Fulfillment &rarr;
              </div>
            </div>
          </Link>
        ))}
      </div>
    </div>
  );
};

export default Orders;